<template>
<v-card flat v-if="!clientUserAgent">

    <table width="100%" border="0" cellpadding="0" class="subtable viewdetail">
        <tr>
            <th align="center" width="30">
                BROKER
            </th>
            <th align="center" width="30"> LOAD </th>
            <th align="center" width="40" class="pos-relative">DESTINATION
                <template v-if="fromComponent == 'loadSearch'">
                    <v-btn v-if="(type == 'load' || type == 'loadRecurring')" depressed outline icon fab dark small class="full-load-btn" :to="'/loadsearch/detail/'+load.uuid" target="_blank">
                        <v-icon class="fa fa-expand orange white--text"></v-icon>
                    </v-btn>
                </template>
                <template v-if="fromComponent == 'loadList'">
                    <v-btn v-if="(type == 'load' || type == 'loadRecurring')" depressed outline icon fab dark small class="full-load-btn" :to="'/myloads/detail/'+load.uuid" target="_blank">
                        <v-icon class="fa fa-expand orange white--text"></v-icon>
                    </v-btn>
                </template>
            </th>
        </tr>
        <tr>
            <td valign="top" align="left" width="30%">
                <div class='unset-case'>
                    <strong>Name: </strong>{{utils.getDataDisplay(load.contact_name)}}<br />

                    <strong>Phone:</strong>
                    <template v-for="(val, idx) in contact_phone_arr">
                        <span v-if="val['val'] == config.notProvidedStr">{{val['val']}}</span>
                        <a v-else class="link-text" target="_blank" :href="'tel:'+val['key']">
                            {{val['val']}}<span v-if="idx < contact_phone_arr.length -1 ">,</span>
                        </a>
                    </template>
                    <br />

                    <template v-if="load.source != 'Vhi Transport'">
                        <strong>Email:</strong>
                            <a v-if="utils.getDataDisplay(load.contact_email) != config.notProvidedStr" class="link-text" target="_blank" :href="'mailto:'+utils.getDataDisplay(load.contact_email)">{{utils.getDataDisplay(load.contact_email)}}</a>
                            <span v-else>{{utils.getDataDisplay(load.contact_email)}}</span>
                        <br />
                    </template>

                    <strong>Company:</strong>
                        <span v-if="type == 'load' || type == 'loadRecurring'">{{utils.getDataDisplay(load.company_name)}}</span>
                        <span v-else>{{utils.getDataDisplay(load.User.company_name)}}</span>
                    <br />

                    <strong>MC Number:</strong>
                        <span v-if="utils.getDataDisplay(load.mc_number) == config.notProvidedStr">{{utils.getDataDisplay(load.mc_number)}}</span>
                        <a v-else-if="type == 'load' || type == 'loadRecurring'" class="link-text" target="_blank" :href="config.mcNumberLocation+utils.getDataDisplay(load.mc_number)">{{utils.getDataDisplay(load.mc_number)}}</a>
                        <span v-else>{{utils.getDataDisplay(load.User.mc_number)}}</span>
                    <br />

                    <template v-if="load.source == 'postonce'">
                        <strong>
                            <span style="text-transform: capitalize;">{{load.source}}</span> 
                            Member Id:
                        </strong> 
                        <span style="text-transform: capitalize;">{{utils.getDataDisplay(load.aggregator_account_name)}}</span>
                        <br />
                    </template>
                    <template v-else >
                        <strong>LOADMAX Forum Username:</strong>
                            <span v-if="(type == 'load' || type == 'loadRecurring')">{{utils.getDataDisplay(load.discourse_user_name)}}</span>
                            <span v-else>{{utils.getDataDisplay(load.User.discourse_user_name)}}</span>
                        <br />
                    </template>
                    <template v-if="((type == 'load' || type == 'loadRecurring') && load.frequency != '')">
                        <strong>Recurring: </strong>{{utils.getDataDisplay(utils.getTitleCase(load.frequency))}}
                        <strong> Until </strong>{{moment(load.end_date).format('YYYY-MM-DD')}}
                        <br />
                    </template>
                </div>
            </td>
            <td valign="top" align="left" width="30%">
                <div class='unset-case'>
                    <strong>Height:</strong> {{load.height}} ft<br /> 
                    <strong>Weight:</strong> {{load.weight}} lbs<br />
                    <strong>Length:</strong> {{load.length}} ft<br />
                    <strong>Equipment and Accessories:</strong> {{load.equipment_name}}<br />
                    <strong>Notes:</strong> {{utils.getNotesNameFromKey(load.notes, aggregatorsKeyVal, load.source)}}<br />
                    <strong>Descriptions and Comments:</strong> {{utils.getDescriptionDisplay(load.description)}}<br />
                    <strong>Load ID:</strong> {{((load.source == 'posteverywhere') ? config.notProvidedStr : utils.getDataDisplay(load.reference_number))}} <br />
                    <span>
                        <strong>Rate:</strong> 
                        <span v-if="load.rate">{{load.rate}}</span>
                        <span v-else>{{config.notProvidedStr}}</span>
                    </span><br />
                    <template v-if="load.load_view_count">
                        <span v-if="fromComponent=='loadList'"><strong>Viewed by:</strong> <a href="javascript:void(0);" @click="loadViewByClick(load)">{{load.load_view_count}} Users</a></span>
                        <span v-else><strong>Viewed by:</strong>{{load.load_view_count}} Users</span>
                    </template>
                </div>
            </td>
            <td valign="top" align="left" width="40%">
                <div style="height:200px;" :id="load.uuid+'-map'"></div>
            </td>
        </tr>
    </table>    
</v-card>
<v-card flat v-else>
    <div class="mobilefullLoad">
        <template v-if="fromComponent=='loadList'">
            <template v-if="load.load_view_count > 0">
                <v-btn v-on:click.stop="loadViewByClick(load)" depressed outline icon fab dark small class=" btn_mob" >
                    <v-icon color="orange">fa-users</v-icon>
                </v-btn>
            </template>
            <template v-else>
                <v-tooltip top>
                    <v-btn slot="activator" v-on:click.stop="" depressed outline icon fab dark small class="btn_mob" >
                        <v-icon color="#8a8a8a">fa-users</v-icon>
                    </v-btn>
                    <span>No one has viewed yet</span>
                </v-tooltip>
            </template>
        </template>

        <template v-if="permissionName=='all' && (load.email == $store.state.user.email) && ((load.is_parent == 0 && load.is_recurring == 0) || (load.is_parent == 1 && load.is_recurring == 1))" class='unset-case'>
            <v-btn :to="{name:'EditLoad', params:{id:load.uuid}}" depressed outline icon fab dark small color="orange"  class="btn_mob">
                <v-icon>fa-edit</v-icon>
            </v-btn>
        </template>
        <v-btn class="custom_table_trash btn_mob" v-if="permissionName=='all' && load.email == $store.state.user.email" depressed outline icon fab dark small color="orange"  v-on:click="DeleteLoadClick(load, type)">
            <v-icon>fa-trash</v-icon>
        </v-btn>
        <v-btn class="full-load-btn-mob" depressed outline icon fab dark small :to="'/myloads/detail/'+load.uuid">
            <v-icon class="fa fa-expand orange white--text"></v-icon>
        </v-btn>
        <div class='unset-case'>
            <h1>BROKER</h1>
            <strong>Name: </strong>{{load.contact_name}}
            <br />

            <strong>Phone:</strong>
            <template v-for="(val, idx) in contact_phone_arr">
                <span v-if="val['val'] == config.notProvidedStr">{{val['val']}}</span>
                <a v-else class="link-text" target="_blank" :href="'tel:'+val['key']">
                    {{val['val']}}<span v-if="idx < contact_phone_arr.length -1 ">,</span>
                </a>
            </template>
            <br />

            <strong>Company:</strong>
            <span v-if="type == 'load' || type == 'loadRecurring'">{{utils.getDataDisplay(load.company_name)}}</span>
            <span v-else>{{utils.getDataDisplay(load.User.company_name)}}</span>
            <br />

            <template v-if="load.source != 'Vhi Transport'">
                <strong>Email:</strong>
                <a v-if="utils.getDataDisplay(load.contact_email) != config.notProvidedStr" class="link-text" target="_blank" :href="'mailto:'+utils.getDataDisplay(load.contact_email)">{{utils.getDataDisplay(load.contact_email)}}</a>
                <span v-else>{{utils.getDataDisplay(load.contact_email)}}</span>
                <br />
            </template>
            
            <strong>MC Number:</strong>
            <a v-if="type == 'load' || type == 'loadRecurring'" class="link-text" target="_blank" :href="config.mcNumberLocation+utils.getDataDisplay(load.mc_number)">{{utils.getDataDisplay(load.mc_number)}}</a>
            <span v-else>{{utils.getDataDisplay(load.User.mc_number)}}</span>
            <br />

            <template v-if="load.source == 'postonce'">
                <strong>
                    <span style="text-transform: capitalize;">{{load.source}}</span> 
                    Member Id:
                </strong> 
                <span style="text-transform: capitalize;">{{utils.getDataDisplay(load.aggregator_account_name)}}</span>
                <br />
            </template>
            <template v-else >
                <strong>LOADMAX Forum Username:</strong>
                    <span v-if="(type == 'load' || type == 'loadRecurring')">{{utils.getDataDisplay(load.discourse_user_name)}}</span>
                    <span v-else>{{utils.getDataDisplay(load.User.discourse_user_name)}}</span>
                <br />
            </template>
            <template v-if="((type == 'load' || type == 'loadRecurring') && load.frequency != '')">
                <strong>Recurring: </strong>{{utils.getDataDisplay(utils.getTitleCase(load.frequency))}}
                <strong> Until </strong>{{moment(load.end_date).format('YYYY-MM-DD')}}
                <br />
            </template>
        </div>
        <div class='unset-case'>
            <h1>LOAD</h1>
                <strong>Height:</strong> {{load.height}} ft<br />
                <strong>Weight:</strong> {{load.weight}} lbs<br />
                <strong>Length:</strong> {{load.length}} ft<br />
                <strong>Equipment and Accessories:</strong> {{load.equipment_name}}<br />
                <strong>Notes:</strong> {{utils.getNotesNameFromKey(load.notes, aggregatorsKeyVal, load.source)}}<br />
                <strong>Descriptions and Comments:</strong> {{utils.getDescriptionDisplay(load.description)}}<br />
                <strong>Load ID:</strong>{{utils.getDataDisplay(load.reference_number)}}<br />
                <span>
                    <strong>Rate:</strong> 
                    <span v-if="load.rate">{{load.rate}}</span>
                    <span v-else>{{config.notProvidedStr}}</span>
                </span><br />
                <span v-if="load.load_view_count"><strong>Viewed by:</strong> <a @click="loadViewByClick(load)"> {{load.load_view_count}} Users</a></span> <br />
        </div>        
    </div>

</v-card>
</template>

<script>
import services from "../../services/HttpService";
import utils from '../../util/';
import config from '../../config';
import moment from 'moment';
export default {
    props: [
        "load",
        "renderMap",
        "type",
        "permissionName",
        "aggregatorsKeyVal",
        "loadViewByClick",
        "clientUserAgent",
        "DeleteLoadClick",
        "fromComponent"
    ],
    created() {
        const self = this;
        self.utils = utils;

        if (!self.clientUserAgent) {
            setTimeout(() => {
                self.renderMap(self.load.uuid + '-map', self.load);
            }, config.setTimeOutForLoadAndTruckDetailMap);
        }
        self.load.contact_name = utils.getDataDisplay(self.load.contact_name);
        self.contact_phone_arr = utils.getPhoneFormatDisplay(self.load.contact_phone);
    },
    mounted() {},
    data() {
        return {
            utils: null,
            config:config,
            contact_phone_arr:[],
            moment:moment
        }
    },
    methods: {

    }
};
</script>



// WEBPACK FOOTER //
// src/pages/loads/LoadInfo.vue